import { render } from "./MultimidiaLeitura.vue?vue&type=template&id=2282aa36&scoped=true"
import script from "./MultimidiaLeitura.vue?vue&type=script&lang=js"
export * from "./MultimidiaLeitura.vue?vue&type=script&lang=js"

import "./MultimidiaLeitura.vue?vue&type=style&index=0&id=2282aa36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2282aa36"]])

export default __exports__